import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <img src="/UniVerseLogo.png" alt="UniVerse Logo" className="footer-logo" />
                <img src="/UniVerseLogo2.png" alt="UniVerse Logo 2" className="footer-logo" />
            </div>
        </footer>
    );
};

export default Footer;